import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class OrganizationsService {
    readonly apiBase: string = '/api/directory/Organizations';

    getOrganizationsShortDetails(orderBy: string, asc: string, top: number, skip: number, isReset: boolean, filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(`${this.apiBase}/OrganizationDTOs`,
            {
                params: {
                    $orderBy: orderBy + ' ' + asc,
                    $top: top,
                    $skip: skip,
                    $count: isReset,
                    ...(filters ? { $filter: manageFilters(filters) } : {})
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getOrganizationAvailable( filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(`${this.apiBase}`,
            {
                params: {
                    ...(filters ? { $filter: manageFilters(filters) } : {})
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    deleteOrgs(orgId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${orgId})`;

        return apiService.delete(apiUrl,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    addOrganization(odataType: string, name: string, homeRealm: string, defaultIssuerUri: string): AxiosPromise {
        return apiService.post(this.apiBase, {
            '@odata.type': odataType,
            Name: name,
            HomeRealm: homeRealm,
            DefaultIssuerUri: defaultIssuerUri
        }).catch((error: AxiosResponse) => Promise.reject(error));
    }

    getOrganization(organizationId: string): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${organizationId})?$expand=Settings,DefaultPolicy`;

        return apiService.get(apiUrl)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    clearOrgLogo(organizationId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${organizationId})/ClearOrgLogo`;

        return apiService.post(apiUrl, {},
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    getActiveSubOrgs(handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/?$filter=Id ne 00000000-0000-0000-0000-000000000000 and ProvisioningState eq Kaseya.AuthAnvil.Models.ProvisionState'Active'&$count=true`;

        return apiService.get(apiUrl,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    uploadOrganizationLogo = (data: any, handleError: Function, handleSuccess: Function): AxiosPromise => {
        const apiUrl: string = `${this.apiBase}/UploadImage`;

        return apiService.post(apiUrl, data,
            { onError: handleError, onSuccess: handleSuccess, headers: {'Content-Type': 'multipart/form-data'} })
            .catch();
    }

    editOrgBasic(organizationId: string, jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${organizationId})/UpdateSettings`;

        return apiService.post(apiUrl, jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    editOrgPasswordPolicy(organizationId: string, jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}(${organizationId})/UpdatePasswordPolicy`;

        return apiService.post(apiUrl, jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    getOrgLimit(handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/GetOrgLimit`;

        return apiService.get(apiUrl,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    forceSignout(organizationId: string): AxiosPromise {
        const apiUrl = `${this.apiBase}(${organizationId})/SetForceSignout`;

        return apiService.post(apiUrl)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
}

export const organizationsService = new OrganizationsService();
